import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params, RouterLink } from '@angular/router';

import { AuthService } from '../../shared/services/auth/auth.service';
import { AssociateService } from '../../associate/shared/services/associate.service';
import { VendorServiceService } from '../../shared/services/vendor-service.service';
import { OrganizationService } from '../../shared/services/organization.service';
import { WorkgroupService } from '../../work-groups/workgroup-services/workgroup.service';
import { Configuration } from '../../app.constants';

@Component({
  selector: 'app-power-search',
  templateUrl: './power-search.component.html',
  styleUrls: ['./power-search.component.css']
})
export class PowerSearchComponent implements OnInit {
// variables for ACL
  public isAdmin: Boolean = false;
  public isLeader: Boolean = false;

  public searchText: string;
  public user: any;
  public tabs= 'associate';

  public associates = [];
  public organizations= [];
  public sites = [];
  public legalEntities = [];
  public teams = [] ;
  public lists = [];
  public workgroups = [];
  public vendors = [];

  // query objects
  public organizationQuery = {
    search : {
        'active': true,
        'company.companyName': { $regex: '', $options: 'i' }
    },
    sort: {
        'company.companyName': 1
    },
    pagination: {
        pageIndex: 0,
        pageSize: 20
    }
  };
  public associateQuery = {
    search : {
        'active': true,
        'personalInformation.fullName': { '$regex': '', '$options': 'i' },
    },
    sort: { 'personalInformation.fullName': 1 },
    pagination: {
        pageIndex: 0,
        pageSize: 20
    }
  };
  public siteQuery = {
    search : {
        'active': true,
        'siteDetails.siteName': { $regex: '', $options: 'i' }
    },
    sort: {
        'siteDetails.siteName': 1
    },
    pagination: {
        pageIndex: 0,
        pageSize: 20
    }
  };
  public legalEntityQuery = {
    search : {
        'active': true,
        'legalEntityName': { $regex: '', $options: 'i' }
    },
    sort: {
        'legalEntityName': 1
    },
    pagination: {
        pageIndex: 0,
        pageSize: 20
    }
  };
  public serverApiUrl;

  tabChange(val: any) {
    this.tabs = val;
    console.log('tabs', this.tabs);
}

  constructor( public router: Router,
    public route: ActivatedRoute,
    public authService: AuthService,
    public assc: AssociateService,
    public vendorService: VendorServiceService,
    public organizationService: OrganizationService,
    public workGroupService: WorkgroupService,
    public config: Configuration) { }

  ngOnInit() {
    this.serverApiUrl = this.config.StaticImageUrl;
    this.user = this.authService.user;
    if (this.user.role === 'Admin' ) {
        this.isAdmin = true;
        this.isLeader = false;
    } else if (this.user.role === 'OpCo Manager' || this.user.role === 'HR Manager') {
        this.isAdmin = false;
        this.isLeader = true;
    }
    this.route.params.subscribe(params => {
      this.searchText = params['searchText'];
      let callCounter = 0;

        // get vendors
        this.vendorService.powerSearch(0, 20, this.searchText).then((data) => {
            this.vendors = data['data'];
            ++callCounter;
            this.openTab(callCounter);
        }, (error) => {
        });
        // get associates
        this.associateQuery.search['personalInformation.fullName'] = { $regex: this.searchText, $options: 'i' };
        this.assc.powerSearch(
            this.associateQuery.pagination.pageIndex,
            this.associateQuery.pagination.pageSize,
            this.associateQuery.search,
            this.associateQuery.sort).then((data) => {
            this.associates = data['data'];
            ++callCounter;
            this.openTab(callCounter);
        }, (error) => {
        });
        // get organizations
        this.organizationQuery.search['company.companyName'] = { $regex: this.searchText, $options: 'i' };
        this.organizationService.powerSearch(
            this.organizationQuery.pagination.pageIndex,
            this.organizationQuery.pagination.pageSize,
            this.organizationQuery.search,
            this.organizationQuery.sort).then((data) => {
                this.organizations = data['data'];
                ++callCounter;
                this.openTab(callCounter);
            }, (error) => {
            });
        // get sites
        this.siteQuery.search['siteDetails.siteName'] = { $regex: this.searchText, $options: 'i' };
        this.organizationService.powersearchSites(
            this.siteQuery.pagination.pageIndex,
            this.siteQuery.pagination.pageSize,
            this.siteQuery.search,
            this.siteQuery.sort
        ).subscribe((data) => {
            this.sites = data['data'];
            ++callCounter;
            this.openTab(callCounter);
        }, (error) => {
        });
         // get legalEntities only for admin, hr-leader and opco-leader
         if ( this.isAdmin || this.isLeader) {
            this.legalEntityQuery.search['legalEntityName'] = { $regex: this.searchText, $options: 'i' };
            this.organizationService.powergetAllLegalEntities(
                this.legalEntityQuery.pagination.pageIndex,
                this.legalEntityQuery.pagination.pageSize,
                this.legalEntityQuery.search,
                this.legalEntityQuery.sort
            ).subscribe((data) => {
                this.legalEntities = data['data'];
                ++callCounter;
                this.openTab(callCounter);
            }, (error) => {
            });
        }
            // get WorkGroups
            this.workGroupService.getWorkGroupsByName(this.searchText).subscribe((data) => {
                this.workgroups = data['data'];
                ++callCounter;
                this.openTab(callCounter);
             }, (error) => {
             });

             // get Teams
             this.organizationService.teamSearch(this.searchText).subscribe((data) => {
                this.teams = data['data'];
                ++callCounter;
                this.openTab(callCounter);
          }, (error) => {
          });
          // get lists of this associate
          this.assc.getAssociate(this.authService.user.associateId).subscribe((data) => {
            this.lists = data['data'][0].listManagment;
            ++callCounter;
            this.openTab(callCounter);
          }, (error) => {
          });
          // open the first tab that has results to display
    });
  }

  openTab(count) {
      if (count === 7) {
        if (this.associates.length === 0) {
            console.log('No associates');
          if (this.organizations.length === 0) {
              console.log('No comnpanies');
              if (this.sites.length === 0) {
                  console.log('No sites');
                  if (this.legalEntities.length === 0) { 
                      console.log('No legal');
                      if (this.teams.length === 0) {
                          console.log('No teams');
                          if (this.workgroups.length === 0) {
                              console.log('No groups');
                              if (this.lists.length === 0)  {
                                  console.log('No lists');
                                  this.tabs= 'associate';
                              } else {
                                  this.tabs = 'lists';
                              }
                          } else {
                              this.tabs = 'workgroups';    
                          }
                      } else {
                          this.tabs = 'teams';
                      }
                  } else {
                      this.tabs = 'legal';
                  }
              } else {
                  this.tabs = 'sites';
              }
          } else {
              this.tabs = 'company';
          }
        } else {
          this.tabs= 'associate';
        }
      }
  }
  reRoute(category: string, id, extraId?) {
    if (category === 'associate') {
        this.router.navigate([`/home/associate/profile/view/${id}`]);
    } else if (category === 'organization') {
        this.router.navigate(['/home/organization/profile/view', id]);
    } else if (category === 'sites') {
        this.router.navigate(['/home/organization/site-profile/view', id]);
    }  else if (category === 'legalEntities') {
        this.router.navigate(['/home/legal-entity/update-legal-entity/', id]);
    } else if (category === 'workgroup') {
        this.router.navigate(['/home/working-group/profile/', id]);
    } else if (category === 'teams') {
        this.router.navigate(['/home/organization/team-profile/view/', id, extraId]);
    }  else if (category === 'list') {
        this.router.navigate(['/home/list/profile/', id]);
    }  else if (category === 'vendors') {
        this.router.navigate(['/home/vendors/profile/view/', id]);
    }
}

}
